<app-expandable-section-box
  [title]="'Version List'"
  [iconClass]="'icon-list-alt'"
  [isExpandedByDefault]="isExpandedByDefault"
  [isExpandable]="isExpandable"
>
  <div class="flex flex-col flex-1 py-3" expandedContent>
    <div
      *ngFor="let version of versions"
      class="flex flex-1 border-b hover:bg-opacity-30"
      [ngClass]="getCssClasses(version.id, version.isSpiked)"
    >
      <div class="flex flex-1 p-1 text-sm">
        <ng-container
          *ngIf="version.id === articleId && !isSpikedOrPublished(version)"
        >
          <div class="flex justify-between flex-1 text-sm">
            <span class="flex flex-1" data-testid="this-version"
              >This version: </span
            ><span class="justify-end">{{
              version.updatedDate | date: "dd/MM/yyyy | HH:mm"
            }}</span>
          </div>
        </ng-container>
        <a
          (click)="redirect(version)"
          class="flex flex-1 font-normal no-underline break-word text-dark hover:cursor-pointer"
          [ngClass]="{ 'font-semibold': version.id === articleId }"
          *ngIf="version.id !== articleId || isSpikedOrPublished(version)"
        >
          <ng-container *ngIf="version.publishingUser">
            <div data-testid="publishing-user" class="flex flex-1 break-word">
              <span class="flex flex-1" data-testid="publish-spiked"
                >{{ getDisplayStatus(version.isSpiked) }} by
                {{ version.publishingUser }}
              </span>
              <span class="justify-end">{{
                version.updatedDate | date: "dd/MM/yyyy | HH:mm"
              }}</span>
            </div>
          </ng-container>
          <ng-container
            *ngIf="!version.publishingUser && version.id !== articleId"
          >
            <span class="flex flex-1" data-testid="unpublished-date"
              >Unpublished version </span
            ><span class="justify-end">{{
              version.updatedDate | date: "dd/MM/yyyy | HH:mm"
            }}</span></ng-container
          >
          <ng-container
            *ngIf="
              !version.publishingUser &&
              version.id !== articleId &&
              !version.publishedDate
            "
            ><span data-testid="unpublished-version">
              Unpublished version
            </span>
          </ng-container>
        </a>

        <div
          *ngIf="version.id !== articleId && repurposedFromArticleId"
          class="flex justify-between text-sm"
        >
          <a
            [routerLink]="[
              '/content',
              contentTypeUrl,
              repurposedFromArticleId,
              '/edit'
            ]"
            class="flex-1 font-normal no-underline text-dark"
            data-testid="repurposed-version"
            >Repurposed from this article</a
          >
        </div>
      </div>
    </div>
  </div>
</app-expandable-section-box>
